import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';

export default class TemplateResource extends BaseResource {
  constructor() {
    super({ url: '/api/artwork' });
  }

  download(id) {
    return super
      .get({ url: `${this.url}/templates${id}/download` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  list(params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .get({ url: `${this.url}/templates${urlParams}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  load(templateId, propertyId) {
    const url = propertyId
      ? `${this.url}/documents?template=${templateId}&property=${propertyId}`
      : `${this.url}/documents?template=${templateId}`;

    return super
      .get({ url })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
